export default __webpack_public_path__ + "static/media/deleteAccFlow.fbd40bbf.png";